import { api } from './palmPayApi';
import type { RegisterPalmRequest } from '../types';

export const getDashboard = async (userId: string): Promise<any> => {
  const response = await api.get('/dashboard', {params: {userId: userId}});
  return response.data;
};

export const registerPalm = async (data: RegisterPalmRequest): Promise<any> => {
  const response = await api.post('/registerPalm', data);
  return response.data;
};

export const verifyPalmReceive = async (data: { 
  userId: string; 
  palmId: string; 
  leftPalmHash?: string; 
  rightPalmHash?: string 
}): Promise<any> => {
  const response = await api.post('/registerPalm/verifyReceive', data);
  return response.data;
};

export const resetPalm = async (data: { userId: string }): Promise<any> => {
  const response = await api.post('/registerPalm/reset', data);
  return response.data;
};

export const getRegisteredUsers = async (search?: string, userId?: string): Promise<any> => {
  const params: any = {};
  if (search) params.search = search;
  if (userId) params.userId = userId;
  
  const response = await api.get('/users', { params });
  return response.data;
};

